import React from 'react';
import {ColorSeparatorLite, ColorWhite} from 'src/styles/Colors';
import Utils from 'src/js/utils/utils';
import AppImage from 'src/js/components/commons/AppImage';
import {RadiusView} from 'src/res/Radius';
import JackpotGameView, {SLOT_GAME_END_DELAY_MS} from './JackpotGameView';
import constants from "../../constants";
import GameAudio from "../commons/GameAudio";
import {GAME_LOSE_AUDIO, GAME_WIN_AUDIO} from "../../utils/GameAudioPlayer";
import FocusHelperView from "../commons/FocusHelperView";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import ImageBackground from "../commons/ImageBackground";
import {logDebug} from "../../utils/AppLog";

const GetDiscoverImageView = React.memo((props) => {
  const {uiConfigs, rows, columns, cardSize, value, cardImage, cardHiddenImage, revealSeries, onCardImageClicked} = props;
  const sizeFactor = uiConfigs.sizeFactor;
  const imageWidth = cardSize * columns;
  const imageHeight = cardSize * rows;
  const spaceTop = 14 * sizeFactor;
  const spaceBottom = 20 * sizeFactor;
  const spaceStartEnd = 16 * sizeFactor;

  const views = [];
  for (let row = 0; row < rows; row++) {
    for (let column = 0; column < columns; column++) {
      views.push(
        <GetDiscoverImageForegroundView
          cardSize={cardSize}
          columns={columns}
          rows={rows}
          row={row}
          column={column}
          value={value}
          cardImage={cardImage}
          revealSeries={revealSeries}
          onCardImageClicked={onCardImageClicked}
        />
      );
    }
  }

  return (
    <ImageBackground source={uiConfigs.cardsBgImage} resizeMode="fill" style={{height: imageHeight + spaceTop + spaceBottom + 1, width: imageWidth + 2 * spaceStartEnd + 1, overflow: 'hidden', borderRadius: RadiusView, paddingTop: spaceTop, paddingBottom: spaceBottom, paddingStart: spaceStartEnd, paddingEnd: spaceStartEnd, alignItems: 'center', justifyContent: 'center'}}>
      <View style={{position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <AppImage imageUrl={cardHiddenImage} style={{width: imageWidth, height: imageHeight, borderRadius: 4}}/>
        <View style={{flexDirection: 'row', flexWrap: 'wrap', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, alignItems: 'center', justifyContent: 'center'}}>
          {views}
        </View>
      </View>
    </ImageBackground>
  );
});

const GetDiscoverImageForegroundView = React.memo((props) => {
  const {cardSize, columns, rows, row, column, value, cardImage, revealSeries, onCardImageClicked} = props;
  const index = row * columns + column;
  const borderTopStartRadius = row === 0 && column === 0 ? 4 : 0;
  const borderTopEndRadius = row === 0 && column === columns - 1 ? 4 : 0;
  const borderBottomStartRadius = row === rows - 1 && column === 0 ? 4 : 0;
  const borderBottomEndRadius = row === rows - 1 && column === columns - 1 ? 4 : 0;

  const onCardImageClickedL = () => {
    onCardImageClicked(cardImage);
  };

  const revealIndex = revealSeries.indexOf(index);
  const isRevealed = revealIndex > -1 && revealIndex < value;
  return (
    <View
      style={{width: cardSize, height: cardSize, borderWidth: 1, border: '1px solid '+ ColorSeparatorLite, backgroundColor: ColorWhite,
        borderTopStartRadius: borderTopStartRadius,
        borderTopEndRadius: borderTopEndRadius,
        borderBottomStartRadius: borderBottomStartRadius,
        borderBottomEndRadius: borderBottomEndRadius,
        opacity: isRevealed ? 0 : 1
    }}>
      <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
        <TouchableOpacity disabled={isRevealed} onClick={onCardImageClickedL}>
          <AppImage
            imageUrl={cardImage}
            style={{
              width: cardSize-2,
              height: cardSize-2,
              borderTopStartRadius: borderTopStartRadius,
              borderTopEndRadius: borderTopEndRadius,
              borderBottomStartRadius: borderBottomStartRadius,
              borderBottomEndRadius: borderBottomEndRadius,
            }}/>
        </TouchableOpacity>
      </View>
    </View>
  );
});

const GetBrandRaceView = React.memo((props) => {
  const {uiConfigs, rows, columns, cardSize, items, onCardImageClicked} = props;
  const sizeFactor = uiConfigs.sizeFactor;
  const imageWidth = cardSize * columns;
  const imageHeight = cardSize * Math.max(columns, 3.5);
  const spaceTop = 22 * sizeFactor;
  const spaceBottom = 22 * sizeFactor;
  const spaceStartEnd = 30 * sizeFactor;

  const views = [];
  for (let column = 0; column < columns; column++) {
    views.push(
      <GetRaceColumnView
        items={items}
        rows={rows}
        columns={columns}
        column={column}
        cardSize={cardSize}
        sizeFactor={sizeFactor}
        onCardImageClicked={onCardImageClicked}/>
    );
  }

  const bgMiddleViews = [];
  for (let column = 2; column < columns; column++) {
    bgMiddleViews.push(
      <ImageBackground source={uiConfigs.gameTopBgMImage} resizeMode="fill" style={{flex: 1, position: 'relative'}} />
    );
  }

  return (
    <View style={{height: imageHeight + spaceTop + spaceBottom + 1, width: imageWidth + 2 * spaceStartEnd + 1, paddingTop: spaceTop, paddingBottom: spaceBottom, paddingStart: spaceStartEnd, paddingEnd: spaceStartEnd, alignItems: 'center', justifyContent: 'center', position: 'relative'}}>
      <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, width: spaceStartEnd + cardSize, flexDirection: 'row'}}>
        <AppImage source={uiConfigs.gameTopBgSImage} resizeMode="fill" style={{width: '100%', height: '100%'}} />
      </View>
      <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, width: spaceStartEnd + cardSize, flexDirection: 'row'}}>
        <AppImage source={uiConfigs.gameTopBgEImage} resizeMode="fill" style={{width: '100%', height: '100%'}} />
      </View>
      <View style={{position: 'absolute', top: 0, bottom: 0, left: spaceStartEnd + cardSize, right: spaceStartEnd + cardSize, flexDirection: 'row'}}>
        {bgMiddleViews}
      </View>
      <View style={{flexDirection: 'row', flex: 1, paddingTop: 8 * sizeFactor, position: 'relative'}}>
        {views}
      </View>
    </View>
  );
});

const GetRaceDottedLines = React.memo((props) => {
  const {progressHeight, sizeFactor, row, rows} = props;
  return <View style={{position: 'absolute', left: 0, right: 0, top: progressHeight * row + 2 * sizeFactor, height: 2, border: '1px dotted '+ Utils.colorWithAlpha(ColorWhite, row === rows ? 0.6 : 0.2)}} />;
});

const GetRaceColumnView = React.memo((props) => {
  const {items, rows, columns, column, cardSize, sizeFactor, onCardImageClicked} = props;
  const imageHeight = cardSize * Math.max(columns, 3.5);
  const slot = items[column];
  const value2 = Math.min(slot.value2 || 0, rows);
  const progressHeight = (imageHeight - cardSize - 8 * sizeFactor) / rows;
  let marginTop = progressHeight * (rows - value2);
  if (value2 >= rows) {
    marginTop = -8 * sizeFactor;
  }

  let dottedLineViews = [];
  for (let row = 1; row <= rows; row++) {
    dottedLineViews.push(
      <GetRaceDottedLines progressHeight={progressHeight} sizeFactor={sizeFactor} row={row} rows={rows} />
    );
  }

  const onCardImageClickedL = () => {
    onCardImageClicked(slot.imageUrl);
  };

  return (
    <View style={{flex: 1, position: 'relative'}}>
      {dottedLineViews}
      <View style={{width: cardSize, height: cardSize, alignItems: 'center', justifyContent: 'center', marginTop: marginTop}}>
        <TouchableOpacity onClick={onCardImageClickedL}>
          <AppImage
            imageUrl={slot.imageUrl}
            style={{
              width: cardSize - 12 * sizeFactor,
              height: cardSize - 12 * sizeFactor,
              borderRadius: RadiusView
            }}/>
        </TouchableOpacity>
      </View>
    </View>
  );
});

const GAME_END_DELAY_MS = 2.2 * 1000;

export default class GameSpinDiscoverView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ideal: true,
    };
  }

  simulatePlay = () => {
    if (this.refSlotView) {
      this.refSlotView.simulatePlay();
    }
  }

  generateRevealSeries() {
    const total = this.props.rows * this.props.columns;
    if (!this.revealSeries || this.revealSeries.length !== total) {
      if (this.props.preview) {
        this.revealSeries = this.generateRandomIndexes(this.props.rows, this.props.columns);
      } else {
        this.revealSeries = this.generateSpiralIndexes(this.props.rows, this.props.columns);
      }
    }
  }

  generateSpiralIndexes(rows, columns) {
    const indexes = [];
    let top = 0;
    let left = 0;
    let bottom = rows - 1;
    let right = columns - 1;
    let direction = 0; // 0: right, 1: down, 2: left, 3: up

    while (top <= bottom && left <= right) {
      if (direction === 0) {
        for (let i = left; i <= right; i++) {
          indexes.push(top * columns + i);
        }
        top++;
      } else if (direction === 1) {
        for (let i = top; i <= bottom; i++) {
          indexes.push(i * columns + right);
        }
        right--;
      } else if (direction === 2) {
        for (let i = right; i >= left; i--) {
          indexes.push(bottom * columns + i);
        }
        bottom--;
      } else if (direction === 3) {
        for (let i = bottom; i >= top; i--) {
          indexes.push(i * columns + left);
        }
        left++;
      }
      direction = (direction + 1) % 4;
    }

    return indexes;
  }

  generateRandomIndexes(rows, columns) {
    const indexes = [];
    for (let i = 0; i < rows * columns; i++) {
      indexes.push(i);
    }
    return Utils.shuffleArray(indexes);
  }

  generateMiddleSpiralIndexes(rows, columns) {
    const indexes = [];
    let top = 0;
    let left = 0;
    let bottom = rows - 1;
    let right = columns - 1;
    const centerX = Math.floor(columns / 2);
    const centerY = Math.floor(rows / 2);

    while (top <= bottom && left <= right) {
      // Traverse the top row
      for (let i = left; i <= right; i++) {
        indexes.push(top * columns + i);
      }
      top++;

      // Traverse the right column
      for (let i = top; i <= bottom; i++) {
        indexes.push(i * columns + right);
      }
      right--;

      // Traverse the bottom row (if it's not the same as the top row)
      if (top <= bottom) {
        for (let i = right; i >= left; i--) {
          indexes.push(bottom * columns + i);
        }
        bottom--;
      }

      // Traverse the left column (if it's not the same as the right column)
      if (left <= right) {
        for (let i = bottom; i >= top; i--) {
          indexes.push(i * columns + left);
        }
        left++;
      }
    }

    // Reorder the indexes starting from the center
    const centerIndex = (centerY * columns) + centerX;
    const centerValue = indexes[centerIndex];
    indexes[centerIndex] = indexes[0];
    indexes[0] = centerValue;

    return indexes;
  }

  componentDidMount() {
    this.setupGamePlayAudio();
  }

  componentWillUnmount() {
    this.releaseGamePlayAudio();
  }

  onAppDidFocus = () => {
    this.isAppInFocus = true;
  };

  onAppDidBlur = () => {
    this.isAppInFocus = false;
  };

  stop(stopData) {
    this.isWin = stopData.isWin;
    this.isSpinComplete = stopData.isSpinComplete;
    if (this.refSlotView) {
      this.refSlotView.stop(stopData);
    }
  }

  reset() {
    this.setState({ideal: true});

    if (this.refSlotView) {
      this.refSlotView.reset();
    }
  }

  resetItems(items) {
    if (this.refSlotView) {
      this.refSlotView.resetItems(items);
    }
  }

  setupGamePlayAudio() {
    // this.releaseGamePlayAudio();
    // GameAudioPlayer.getInstance().load(GAME_PLAY_AUDIO, (assetId) => {
    //   this.gamePlayAudioId = assetId;
    // }, true);
    // GameAudioPlayer.getInstance().load(GAME_SLOT_END_AUDIO, (assetId) => {
    //   this.gamePlayAudioId1 = assetId;
    // }, true);
  }

  releaseGamePlayAudio() {
    // if (this.gamePlayAudioId) {
    //   GameAudioPlayer.getInstance().release(this.gamePlayAudioId);
    // }
    // if (this.gamePlayAudioId1) {
    //   GameAudioPlayer.getInstance().release(this.gamePlayAudioId1);
    // }
  }

  playGameLoseAudio() {
    if (this.isAppInFocus) {
      // if (this.props.gameLoseAudioUrl) {
      //     this.gameAudioPlayer.playInline(this.props.gameLoseAudioUrl);
      // } else {
      //     this.gameAudioPlayer.playLoseAudio();
      // }
      if (this.gamePlayAudioIdLose) {
        this.gamePlayAudioIdLose.play();
      }
    }
  }

  playGameWinAudio() {
    if (this.isAppInFocus) {
      // if (this.props.gameWinAudioUrl) {
      //     this.gameAudioPlayer.playInline(this.props.gameWinAudioUrl);
      // } else {
      //     this.gameAudioPlayer.playWinAudio();
      // }
      if (this.gamePlayAudioIdWin) {
        this.gamePlayAudioIdWin.play();
      }
    }
  }

  render() {
    if (!this.props.contentHeight) {
      return null;
    }

    const columns = this.props.columns;
    const cardSize = this.getCardSize();
    let gameTopView = null;
    if (this.props.gameType === constants.activity.types.GAME_SPIN_N_DISCOVER) {
      this.generateRevealSeries();
      gameTopView = (
        <GetDiscoverImageView
          uiConfigs={this.props.uiConfigs}
          rows={this.props.rows}
          columns={this.props.columns}
          cardSize={this.getCardSizeTopView()}
          value={this.props.value}
          cardImage={this.props.cardImage}
          cardHiddenImage={this.props.cardHiddenImage}
          revealSeries={this.revealSeries}
          onCardImageClicked={this.onCardImageClicked} />
      );
    } else if (this.props.gameType === constants.activity.types.GAME_BRAND_RACE) {
      gameTopView = (
        <GetBrandRaceView
          uiConfigs={this.props.uiConfigs}
          rows={this.props.rows}
          columns={this.props.columns}
          cardSize={this.getCardSize()}
          items={this.props.items}
          onCardImageClicked={this.onCardImageClicked} />
      );
    }
    const slotCardSize = Math.max((cardSize * columns - this.props.sColumns * 5) / this.props.sColumns, Utils.isWindowSmallHeight() ? 80 : 90);
    return (
      <View style={{alignItems: 'center'}}>
        <FocusHelperView
          onAppDidFocus={this.onAppDidFocus}
          onAppDidBlur={this.onAppDidBlur}
        />
        {!this.props.disableAudio ?
          <div>
            <GameAudio ref={(ref) => this.gamePlayAudioIdLose = ref} source={this.props.gameLoseAudioUrl || GAME_LOSE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={this.props.gameWinAudioUrl || GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
          </div>
          : null
        }

        {gameTopView}
        <JackpotGameView
          ref={(ref) => this.refSlotView = ref}
          disableAudio={this.props.disableAudio}
          noActionMode={this.props.noActionMode}
          onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
          mute={this.props.mute}
          preview={this.props.preview}
          classes={this.props.classes}
          contentWidth={this.props.width}
          contentHeight={this.props.contentHeight}
          uiConfigs={this.props.uiConfigs}
          isLTR={this.props.isLTR}
          items={this.props.items}
          columns={this.props.sColumns}
          hideSpin={this.props.hideSpin}
          rows={1}
          disableEndAudio={false}
          gamePlayAudioUrl={this.props.gamePlayAudioUrl}
          gameWinAudioUrl={this.props.gameWinAudioLocalUrl}
          gameLoseAudioUrl={this.props.gameLoseAudioLocalUrl}
          cardSize={cardSize}
          maxCardSize={slotCardSize}
          spinsLeft={this.props.spinsLeft}
          spinsCount={this.props.spinsCount}
          canSpin={this.props.canSpin}
          onImageClicked={this.props.onImageClicked}
          onSpinStarted={() => {
            this.setState({ideal: false});
            if (this.props.onSpinStarted) {
              this.props.onSpinStarted();
            }
          }}
          onSpinStopped={() => {
            this.spinStopped();
          }}
        />
        {this.props.hideSpin ? <View style={{height: 8}}/> : null}
      </View>
    );
  }

  onCardImageClicked = (imageUrl) => {
    this.props.onImageClicked(imageUrl);
  };

  spinStopped() {
    if (this.isWin) {
      this.isWin = false;
      this.playGameWinAudio();
    } else if (this.isSpinComplete) {
      this.playGameLoseAudio();
    }
    // Vibration.vibrate(200);

    let delay = this.isWin ? 800 : SLOT_GAME_END_DELAY_MS;
    if (this.isWin || this.isSpinComplete) {
      delay = GAME_END_DELAY_MS;
    }
    setTimeout(() => {
      this.setState({ideal: true});
      if (this.props.onSpinStopped) {
        this.props.onSpinStopped();
      }
    }, delay);
  }

  getCardSizeTopView() {
    if (this.props.gameType === constants.activity.types.GAME_BRAND_RACE) {
      return this.getCardSize();
    }

    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    let columns = this.props.columns;
    let rows = this.props.rows;
    let cardSpacing = 0;
    let borderWidth = uiConfigs ? uiConfigs.topViewMargin : 30;

    const otherUiHeight = 150 * sizeFactor;
    const possibleWidth = (this.props.contentWidth - 2 * borderWidth * sizeFactor - (columns - 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - 2 * borderWidth * sizeFactor - otherUiHeight - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card

    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const maxCardSize = this.props.maxCardSize || 120;
    const cardSize = Math.floor(Math.min(maxCardSize, possibleSize));
    logDebug('cardSize', cardSize);
    return cardSize;
  }

  getCardSize() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    let columns = this.props.columns;
    let rows = this.props.rows;
    let cardSpacing = 0;
    let otherUiHeight = 140 * sizeFactor;
    let borderWidth = uiConfigs ? uiConfigs.topViewMargin : 30;
    if (this.props.gameType === constants.activity.types.GAME_BRAND_RACE) {
      otherUiHeight = 180 * sizeFactor;
      rows = 3.5; // consider rows as 3.5 and use the same space in height and divide in given rows
      cardSpacing = 4 * sizeFactor;
    } else {
      columns = Math.max(this.props.columns, this.props.sColumns);
    }

    const possibleWidth = (this.props.contentWidth - 2 * borderWidth * sizeFactor - (columns - 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - 2 * borderWidth * sizeFactor - otherUiHeight - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card

    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const maxCardSize = this.props.maxCardSize || 200;
    const cardSize = Math.floor(Math.min(maxCardSize, possibleSize));
    logDebug('cardSize', cardSize);
    return cardSize;
  }
}
